import { memo } from "react";
import { Star, Clock, ShieldCheck, MapPin } from "lucide-react";

const TrustItem = ({ icon: Icon, title, subtitle, dark }) => (
  <div className="flex items-center gap-3 icon-spin">
    <div className={`w-12 h-12 lg:w-14 lg:h-14 rounded-xl flex items-center justify-center shrink-0 ${dark ? "bg-slate-900" : "bg-red-100 pulse-glow"}`}>
      {Icon ? <Icon className={`h-6 w-6 lg:h-7 lg:w-7 ${dark ? "text-white" : "text-red-600"}`} /> : (
        <svg className="h-6 w-6 lg:h-7 lg:w-7 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
        </svg>
      )}
    </div>
    <div>
      <p className="font-semibold text-slate-900 text-sm lg:text-base">{title}</p>
      <p className="text-xs lg:text-sm text-slate-500">{subtitle}</p>
    </div>
  </div>
);

export const TrustSignalsSection = memo(() => (
  <section className="bg-slate-50 py-8 border-y" data-testid="trust-signals-section">
    <div className="container-custom">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
        <TrustItem icon={Star} title="4,6/5 sur Google" subtitle="212 avis clients" />
        <TrustItem dark title="Spécialiste Apple" subtitle="iPhone, iPad, Mac" />
        <TrustItem icon={Clock} title="Réparation express" subtitle="Dès 30 minutes" />
        <TrustItem icon={ShieldCheck} title="Garantie 6 mois" subtitle="Sur toutes réparations" />
        <TrustItem icon={MapPin} title="À Niort" subtitle="104 Rue de la Gare" />
      </div>
    </div>
  </section>
));

TrustSignalsSection.displayName = "TrustSignalsSection";
